<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card card-body-classes="table-full-width" :title="$t('users.users')" :on-cancel="cancel">
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="col-12 col-md-4 col-sm-6 mb-2">
          <el-input
            v-model="searchQuery"
            class="search-input"
            clearable
            :prefix-icon="Search"
            :placeholder="$t('common.searchRecords')"
            aria-controls="datatables"
            @keyup="search"
            @clear="handleClearSearch"
          />
        </div>
  
      </div>
      <el-table :data="users">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
  
        >
        </el-table-column>
        <el-table-column :min-width="135" align="right" label="">
          <template #default="{ row }">
            <material-button
              color="info"
              variant="outline"
              size="sm"
              class="btn-icon btn-fab"
              @click="reserve(row.id)"
            >
              <i class="material-icons">star_border</i>
            </material-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap pagination">
      <div class="">
        <p class="card-category">
          {{ $t('pagination.showing') }} {{ from + 1 }} {{ $t('pagination.to') }} {{ to }} {{ $t('pagination.of') }} {{ total }} {{ $t('pagination.entries') }}
        </p>
      </div>
      <material-pagination color="info" class="pagination-no-border">
        <material-pagination-item
          prev
          :disabled="pagination.currentPage === 1"
          @click="prevPage"
        />
        <material-pagination-item
          v-for="page in displayedPages"
          :key="page"
          :label="String(page)"
          :active="pagination.currentPage === page"
          @click="changePage(page)"
        />
        <material-pagination-item
          next
          :disabled="pagination.currentPage === totalPages"
          @click="nextPage"
        />
      </material-pagination>
    </div>
  </card>
  </template>
  <script>
  import api from "../../services/api"
  import { ElTable, ElTableColumn, ElInput } from 'element-plus';
  import { Search } from '@element-plus/icons-vue';
  import MaterialPagination from '../../components/MaterialPagination.vue';
  import MaterialPaginationItem from '../../components/MaterialPaginationItem.vue';
  import MaterialButton from '../../components/MaterialButton.vue';
  
  export default {
  name: 'UserReserveTable',
  components: {
    MaterialPagination,
    MaterialPaginationItem,
    MaterialButton,
    ElTable,
    ElTableColumn,
    ElInput
    },
  props: {
    toolGroupId: {
      type: [String, Number],
      default: null
    },
    // Shared with vinnuvélar, which need their own wording on the success toast
    successMessage: {
      type: String,
      default: null
    }
  },
  emits: ['close', 'refresh-data'],

  data() {
      return {
        Search,
        pagination: {
          perPage: 5,
          currentPage: 1,
          total: 0
        },
        tableColumns: [
          {
            prop: 'name',
            label: this.$t('common.name'),
            minWidth: 150
          }
        ],
        searchQuery: '',
        users: [],
        initalPage: true
      };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    totalPages() {
      if (this.total > 0) {
        return Math.ceil(this.total / this.pagination.perPage);
      }
      return 1;
    },
    displayedPages() {
      const pages = [];
      const maxPages = Math.min(5, this.totalPages);

      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxPages / 2));
      let endPage = startPage + maxPages - 1;

      if (endPage > this.totalPages) {
        endPage = this.totalPages;
        startPage = Math.max(1, endPage - maxPages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
    },
  created() {
      this.fetchUserData()
  },
  methods: {
    search(event){
      const queryLength = this.searchQuery.length;
      this.pagination.currentPage = 1;
  
      if (event.key === 'Backspace' || event.key === 'Enter') {
        this.fetchUserData();
      }
      else {
        if (queryLength > 1) {
          if (queryLength % 2 === 0) {
            this.fetchUserData();
          }
        }
      }
    },
    handleClearSearch(){
      this.fetchUserData();
  
    },
    updatePage(item){
      this.pagination.currentPage = item;
      this.fetchUserData()
    },
    changePage(page) {
      if (page !== this.pagination.currentPage && page >= 1 && page <= this.totalPages) {
        this.pagination.currentPage = page;
        this.fetchUserData();
      }
    },
    nextPage() {
      if (this.pagination.currentPage < this.totalPages) {
        this.changePage(this.pagination.currentPage + 1);
      }
    },
    prevPage() {
      if (this.pagination.currentPage > 1) {
        this.changePage(this.pagination.currentPage - 1);
      }
    },
    cancel()
    {
      this.$emit('close');
    },
    fetchUserData()
    {
        let getUsersUrl = ''
        if(this.searchQuery === '')
        {
            getUsersUrl = `/User?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&excludeImages=true`
        }
        else
        {
          getUsersUrl = `/User?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&name=${this.searchQuery}&excludeImages=true`
        }
        api.get(getUsersUrl)
        .then(response => {
            this.pagination.total = response.data.totalItems;
            this.users = response.data.result.map(item => {
            return {
                id: item.id,
                name: item.firstName + ' ' + item.lastName,
            };
            });
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 });
        });
  },
  async reserve(userId) {
    try {
      await api.post('/ToolGroup/Reserve', {
        toolGroupId: this.toolGroupId,
        userId: userId
      });
      this.$toast.success(this.successMessage || this.$t('cars.carReserved'), { timeout: 1500 });
    } catch (error) {
      console.error('API request error:', error); // eslint-disable-line no-console
      this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
    }
    this.$emit('refresh-data');
    this.$emit('close');
    }
  },
  };
  </script>
  <style></style>